module.exports = __webpack_public_path__ + "static/media/ascorel.8b038ff2.png";